import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { Link } from 'react-router-dom';
import { Card, Col, Container, Input, Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import baseUrl from '../../helpers/baseurl';

import classnames from 'classnames';
import moment from 'moment';
import Select from 'react-select';
import { BackButton } from '../../components/Common/BackButton';
import Breadcrumb from '../../components/Common/Breadcrumb';
import Table1 from "../../components/Common/TableContainer";
import { getCustomers } from "../../store/catalogs/Customers/actions";
import { getLabAreas } from "../../store/catalogs/LabAreas/actions";
import { getTechAdvisors } from "../../store/catalogs/Users/actions";
import { getLabRequestReportRois } from "../../store/labCitec/labRequestReportsRoi/actions";
import { retrieveCustomDate } from "../../helpers/dateHelper";
import { BaseCustomButton, userRoles } from '../../shared';
import { DEFAULT_PAGE_SIZE, DEFAULT_PAGE } from '../../constants/tables';

export const Roi = (props) => {
    // To switch tabs in the expander component
    let [activeTab, setActiveTab] = useState('1');
    const [labAreaFilter, setLabAreaFilter] = useState('');
    const [customerFilter, setCustomerFilter] = useState('');
    const [techAdvFilter, setTechAdvFilter] = useState('');
    const [initialDate, setInitialDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [dateFilter, setDateFilter] = useState('');
    const [serviceFilter, setServiceFilter] = useState('');
    const [pageSizeCitec, setPageSizeCitec] = useState(DEFAULT_PAGE_SIZE);
    const [pageSizeMovil, setPageSizeMovil] = useState(DEFAULT_PAGE_SIZE);
    const [paginationQuery, setPaginationQuery] = useState(`?limit=${DEFAULT_PAGE_SIZE}&page=${DEFAULT_PAGE}`);

    const citec = localStorage?.getItem("CITEC") ? JSON.parse(localStorage?.getItem("CITEC") ?? `{"labType": '1' }`) : '0';
    const movil = localStorage?.getItem("Movil") ? JSON.parse(localStorage?.getItem("Movil") ?? `{"lId": '1' }`) : '0';

    const dispatch = useDispatch();

    let [filterQuery, setFilterQuery] = useState('');

    const profiletoggle = tab => {
        if (activeTab !== tab) {
            activeTab = tab;
            setActiveTab(tab);
        }
    };

    useEffect(() => {
        setLabAreaFilter('');
        setCustomerFilter('');
        setTechAdvFilter('');
        setInitialDate('');
        setEndDate('');
        setDateFilter('');
        setServiceFilter('');
        setFilterQuery('');
        dispatch(getCustomers(`?limit=100&page=${DEFAULT_PAGE}`));
        dispatch(getTechAdvisors(`?limit=100&page=${DEFAULT_PAGE}&userType=${userRoles.technicalAdvisor}`));
        if (activeTab === '2') {
            dispatch(getLabAreas(`?limit=100&page=${DEFAULT_PAGE}&search=Móvil`));
            dispatch(getLabRequestReportRois(`?limit=${pageSizeMovil}&page=${DEFAULT_PAGE}&reportType=roi&laboratoryType=${movil}`));
            setPaginationQuery(`?limit=${pageSizeMovil}&page=${DEFAULT_PAGE}`);
        } else if (activeTab === '1') {
            dispatch(getLabAreas(`?limit=100&page=${DEFAULT_PAGE}&search=CITEC`));
            dispatch(getLabRequestReportRois(`?limit=${pageSizeCitec}&page=${DEFAULT_PAGE}&reportType=roi&laboratoryType=${citec}`));
            setPaginationQuery(`?limit=${pageSizeCitec}&page=${DEFAULT_PAGE}`);
        }
    }, [activeTab]);

    const {
        users,
        loading,
        total,
        currentPage,
        labareas,
        labRequestReportRois,
        techAdvisors,
        customers
    } = useSelector(state => ({
        loading: state.labRequestReportRoiReducer.loading,
        total: state.labRequestReportRoiReducer.total,
        currentPage: state.labRequestReportRoiReducer.currentPage,
        techAdvisors: state.usersReducer.techAdvisors,
        users: state.usersReducer.users,
        customers: state.customersReducer.customers,
        labareas: state.labAreas.labareas,
        labRequestReportRois: state.labRequestReportRoiReducer.labRequestReportRois,
    }));

    const onSearch = () => {
        const queryParts = [];

        // Basic filters
        if (labAreaFilter) queryParts.push(`laboratoryArea=${labAreaFilter}`);
        if (techAdvFilter && techAdvFilter.id) queryParts.push(`technicalAdviser=${techAdvFilter.id}`);
        if (customerFilter && customerFilter.id) queryParts.push(`customer=${customerFilter.id}`);
        if (serviceFilter) queryParts.push(`search=${serviceFilter}`);

        // Date filters
        if (initialDate && endDate) {
            let filterType = '';
            if (dateFilter === '1') filterType = 'request_date';
            else if (dateFilter === '2') filterType = 'initial_date';
            else if (dateFilter === '3') filterType = 'final_date';

            if (filterType) {
                queryParts.push(`dateFilterType=${filterType}`);
                queryParts.push(`initialDatedAt=${initialDate}`);
                queryParts.push(`finalDatedAt=${endDate}`);
            }
        }

        // Final query string
        const query = `&${queryParts.join('&')}`;

        // Save query to state
        setFilterQuery(query);

        // Determine lab type
        const laboratoryType = activeTab === '1' ? citec : movil;
        dispatch(getLabRequestReportRois(`?limit=${activeTab === '1' ? pageSizeCitec : pageSizeMovil}&page=${DEFAULT_PAGE}${query}&reportType=roi&laboratoryType=${laboratoryType}`));
    };


    const onDateFilterChange = (value) => {
        setDateFilter(value.target.value)
        setEndDate('')
        setInitialDate('')
    }

    const getPagination = (params) => {
        setPaginationQuery(params);
        dispatch(getLabRequestReportRois(`${params}${filterQuery}&reportType=roi&laboratoryType=${activeTab === '2' ? movil : citec}`));
    }

    const onSearchChange = (value) => {
        setServiceFilter(value.target.value)
    }

    const columns = React.useMemo(
        () => [
            {
                Header: 'Detalle del Cliente',
                width: '23%',
                Cell: ({ row }) => (
                    <div className='d-flex'>
                        <div>
                            <div style={{ fontSize: 12 }} className='text-start pb-3'>
                                <strong>Folio: </strong>{row.original?.code ?? '-'}
                            </div>
                            <div style={{ fontSize: 12 }} className='text-start pb-3'>
                                <strong>Cliente: </strong>{row.original?.customer?.name ?? '-'}
                            </div>
                            <div style={{ fontSize: 12 }} className='text-start pb-3'>
                                <strong>Asesor Técnico: </strong>{`${row.original?.technicalAdviser?.name ?? ''} ${row.original?.technicalAdviser?.surname ?? ''}` ?? '-'}
                            </div>
                        </div>
                        <hr
                            className='ms-2 me-3 my-0 text-success'
                            style={{
                                height: 150,
                                width: 4,
                            }}
                        />
                        <div>
                            <div style={{ fontSize: 12 }} className='text-start pb-3'>
                                <strong>Laboratorio: </strong>{row.original?.laboratory?.name ?? '-'}
                            </div>
                            <div style={{ fontSize: 12 }} className='text-start pb-3'>
                                <strong>Área de laboratorio: </strong>{row.original?.laboratoryArea?.name ?? '-'}
                            </div>
                            <div style={{ fontSize: 12 }} className='text-start pb-3'>
                                <strong>Coordinación: </strong>{row.original?.coordination?.name ?? '-'}
                            </div>
                            <div style={{ fontSize: 12 }} className='text-start pb-3'>
                                <strong>Segmento: </strong>{row.original?.laboratorySegment?.name ?? '-'}
                            </div>
                        </div>
                    </div>
                ),
            },
            {
                Header: 'Descripción',
                width: '11%',
                Cell: ({ row }) => (
                    <div>
                        <div style={{ fontSize: 12 }} className='text-left'>
                            {
                                (row.original.description)
                            }
                        </div>
                    </div>
                ),
            },
            {
                Header: 'Fechas',
                width: '15%',
                Cell: ({ row }) => (
                    <div>
                        <div className="d-flex justify-content-between mx-2">
                            <div style={{ fontSize: 12 }}>
                                <b>Fecha de solicitud:         </b>
                            </div>
                            <div style={{ fontSize: 12 }}>
                                {
                                    retrieveCustomDate(
                                        row.original.requestStatus,
                                        row.original.updatedAt,
                                        row.original.createdAt,
                                        row.original.createdRecordAt)
                                }
                            </div>
                        </div>
                        <div className="d-flex justify-content-between mx-2 mt-3">
                            <div style={{ fontSize: 12 }}>
                                <b>Fecha de recepción de muestras:</b>
                            </div>
                            <div style={{ fontSize: 12 }}>
                                {row.original.startedAt ? moment(row.original.startedAt).utc().format('YYYY-MM-DD') : '-'}
                            </div>
                        </div>
                        <div className="d-flex justify-content-between mx-2 mt-3">
                            <div style={{ fontSize: 12 }}>
                                <b>Fecha de aceptación de solicitudes:</b>
                            </div>
                            <div style={{ fontSize: 12 }}>
                                {row.original.endedAt ? moment(row.original.endedAt).utc().format('YYYY-MM-DD') : '-'}
                            </div>
                        </div>
                    </div>
                ),
            },
            {
                Header: 'Inversiones',
                width: '17%',
                Cell: ({ row }) => (
                    <div>
                        <div style={{ fontSize: 12 }} className='d-flex justify-content-between px-3'>
                            <strong>Número de ensayos: </strong>
                            {
                                row.original.labRequestTest?.map((element, index) => {
                                    const arr = []
                                    element?.labRequestTestSample?.forEach(element2 => {
                                        arr.push(element2.essays)
                                    });

                                    return (
                                        arr.reduce((a, b) => a + b, 0)
                                    )
                                }).reduce((a, b) => a + b, 0)
                            }
                        </div>
                        <hr className='m-2' style={{ height: 1 }} />
                        <div style={{ fontSize: 12 }} className='d-flex justify-content-between px-3'>
                            <strong>Costo de mano de Obra: </strong>
                            $ {
                                row.original.labRequestTest?.map((element, index) => {
                                    const arr = []
                                    element?.labRequestTestSample?.forEach(element2 => {
                                        arr.push(element2.essays * element?.labTest?.workforceCost)
                                    });

                                    return (
                                        arr.reduce((a, b) => a + b, 0)
                                    )
                                }).reduce((a, b) => a + b, 0)?.toLocaleString('en-US', { maximumFractionDigits: 2 })
                            }
                        </div>
                        <hr className='m-2' style={{ height: 1 }} />
                        <div style={{ fontSize: 12 }} className='d-flex justify-content-between px-3'>
                            <strong>Costos de materiales: </strong>
                            $ {
                                row.original.labRequestTest?.map((element, index) => {
                                    const arr = []
                                    element?.labRequestTestSample?.forEach(element2 => {
                                        arr.push(element2.essays * element?.labTest?.materialCost)
                                    });

                                    return (
                                        arr.reduce((a, b) => a + b, 0)
                                    )
                                }).reduce((a, b) => a + b, 0)?.toLocaleString('en-US', { maximumFractionDigits: 2 })
                            }
                        </div>
                        <hr className='text-success m-2' style={{ height: 3 }} />
                        <div style={{ fontSize: 12 }} className='d-flex justify-content-between px-3'>
                            <strong>Inversión Total: </strong>
                            $ {
                                row.original.labRequestTest?.map((element, index) => {
                                    const arr = []
                                    element?.labRequestTestSample?.forEach(element2 => {
                                        arr.push(element2.essays * element?.labTest?.totalCost)
                                    });

                                    return (
                                        arr.reduce((a, b) => a + b, 0)
                                    )
                                }).reduce((a, b) => a + b, 0)?.toLocaleString('en-US', { maximumFractionDigits: 2 })
                            }
                        </div>
                        <hr className='text-success m-2' style={{ height: 3 }} />
                        <div style={{ fontSize: 12 }} className='d-flex justify-content-between px-3'>
                            <strong>Costos de Tercero: </strong>
                            $ {
                                row.original.labRequestTest?.map((element, index) => {
                                    const arr = []
                                    element?.labRequestTestSample?.forEach(element2 => {
                                        arr.push(element2.essays * element?.labTest?.thirdCost)
                                    });

                                    return (
                                        arr.reduce((a, b) => a + b, 0)
                                    )
                                }).reduce((a, b) => a + b, 0)?.toLocaleString('en-US', { maximumFractionDigits: 2 })
                            }
                        </div>
                    </div>
                ),
            },
            {
                Header: 'Beneficios',
                width: '8%',
                Cell: ({ row }) => (
                    <div>
                        <div style={{ fontSize: 12 }} className='text-left'><strong>Beneficio Total (MXN)</strong></div>
                        <div style={{ fontSize: 12 }} className='text-left'>
                            $ {
                                (row.original.labRequestTest?.map((element, index) => {
                                    const arr = []
                                    element?.labRequestTestSample?.forEach(element2 => {
                                        arr.push(element2.essays * element?.labTest?.thirdCost)
                                    });

                                    return (
                                        arr.reduce((a, b) => a + b, 0)
                                    )
                                }).reduce((a, b) => a + b, 0) -
                                    row.original.labRequestTest?.map((element, index) => {
                                        const arr = []
                                        element?.labRequestTestSample?.forEach(element2 => {
                                            arr.push(element2.essays * element?.labTest?.totalCost)
                                        });

                                        return (
                                            arr.reduce((a, b) => a + b, 0)
                                        )
                                    }).reduce((a, b) => a + b, 0))?.toLocaleString('en-US', { maximumFractionDigits: 2 })
                            }
                        </div>
                        <hr className='text-success m-2' style={{ height: 3 }} />
                    </div>
                ),
            },
            {
                Header: 'ROI(%)',
                width: '6%',
                Cell: ({ row }) => (
                    <div >
                        <div style={{ fontSize: 12 }} className='text-success'><strong>
                            {
                                (row.original.labRequestTest?.map((element, index) => {
                                    const arr = []
                                    element?.labRequestTestSample?.forEach(element2 => {
                                        arr.push(element2.essays * element?.labTest?.thirdCost)
                                    });
                                    return (
                                        arr.reduce((a, b) => a + b, 0)
                                    )
                                }).reduce((a, b) => a + b, 0)) !== 0 ?
                                    (((row.original.labRequestTest?.map((element, index) => {
                                        const arr = []
                                        element?.labRequestTestSample?.forEach(element2 => {
                                            arr.push(element2.essays * element?.labTest?.thirdCost)
                                        });
                                        return (
                                            arr.reduce((a, b) => a + b, 0)
                                        )
                                    }).reduce((a, b) => a + b, 0) -
                                        row.original.labRequestTest?.map((element, index) => {
                                            const arr = []
                                            element?.labRequestTestSample?.forEach(element2 => {
                                                arr.push(element2.essays * element?.labTest?.totalCost)
                                            });
                                            return (
                                                arr.reduce((a, b) => a + b, 0)
                                            )
                                        }).reduce((a, b) => a + b, 0)) * 100) / (row.original.labRequestTest?.map((element, index) => {
                                            const arr = []
                                            element?.labRequestTestSample?.forEach(element2 => {
                                                arr.push(element2.essays * element?.labTest?.thirdCost)
                                            });

                                            return (
                                                arr.reduce((a, b) => a + b, 0)
                                            )
                                        }).reduce((a, b) => a + b, 0))).toFixed(2) : 0
                            } %
                        </strong></div>
                    </div>
                ),
            },
            {
                width: '7%',
                Header: "Acciones",
                Cell: ({ row }) => (
                    <div className="page-title-box d-flex align-items-center justify-content-center row">
                        <Link
                            to={{ pathname: `/roi/${row.original?.id}` }}
                            className='d-flex align-items-center justify-content-center mb-1'
                        >
                            <BaseCustomButton
                                color="primary"
                                label="Resumen"
                                outline
                                icon="mdi-18px mdi-bell-circle-outline"
                                className="col-12 mb-2"
                            />
                        </Link>

                        <Link
                            to={{ pathname: `/labCitec/${row.original?.id}` }}
                            className='d-flex align-items-center justify-content-center mb-1'
                        >
                            <BaseCustomButton
                                color='success'
                                label='Detalles'
                                outline
                                icon="mdi-18px mdi-launch"
                                className="col-12 mb-2"
                            />
                        </Link>
                    </div>
                ),
            }

        ],
        []
    )

    const dataCitec = [
        {
            folio: 'CITEC-PR-22-02',
            client: '111110000 - Cliente Genérico',
            techAdv: 'José Dolores Castillo Pascual',
            lab: 'CITEC TOLUCA',
            area: 'Cemento',
            coordination: 'Servicios Técnicos',
            segment: 'Infraestructura',
            requestDate: '2022-12-30',
            startWorkingDate: '2022-12-30',
            finalReportDate: '2022-12-30',
            numberOfTest: '2',
            workforceCost: '7500',
            materialCosts: '3500',
            totalInvestment: '11000',
            thirdPartyCosts: '12000',
            totalBenefit: '1000',
            roi: '3%',
        },
    ]

    const dataMovil = [
        {
            folio: 'CITEC-PR-22-02',
            client: '111110000 - Cliente Genérico',
            techAdv: 'José Dolores Castillo Pascual',
            lab: 'CITEC TOLUCA',
            area: 'Cemento',
            coordination: 'Servicios Técnicos',
            segment: 'Infraestructura',
            requestDate: '2022-12-30',
            startWorkingDate: '2022-12-30',
            finalReportDate: '2022-12-30',
            numberOfTest: '2',
            workforceCost: '7500',
            materialCosts: '3500',
            totalInvestment: '11000',
            thirdPartyCosts: '12000',
            totalBenefit: '1000',
            roi: '3%',
        },
    ]

    return (
        <>
            <div className="page-content">
                <Container fluid className="" >
                    <Col className="col-12" style={{ padding: 20 }}>
                        <Card className='' style={{ padding: 50 }}>

                            <div className='d-flex justify-content-between'>
                                <Breadcrumb breadcrumbItem1='roi' />
                                <BackButton props={props} />
                            </div>

                            <Card className='' style={{ padding: 20 }}>

                                <div className='px-4 mx-3'>

                                    <Nav tabs className="nav-tabs-custom nav-justified">
                                        <NavItem >
                                            <NavLink
                                                style={{ cursor: "pointer" }}
                                                className={classnames({ active: activeTab === '1' })}
                                                onClick={() => { profiletoggle('1'); }}
                                            >
                                                Servicios Laboratorio CITEC
                                            </NavLink>
                                        </NavItem>
                                        <NavItem>
                                            <NavLink
                                                style={{ cursor: "pointer" }}
                                                className={classnames({ active: activeTab === '2' })}
                                                onClick={() => { profiletoggle('2'); }}
                                            >
                                                Servicios Laboratorio Móvil
                                            </NavLink>
                                        </NavItem>
                                    </Nav>

                                    <TabContent activeTab={activeTab} className="px-0 py-4">

                                        <TabPane tabId='1'>
                                            <div className='d-flex align-items-start justify-content-start'>

                                                <div className="col-3 col-md-3 mx-2">
                                                    <label className='text-primary ml-1'>Área de Laboratorio</label>
                                                    <select
                                                        className="form-select text-primary rounded-3"
                                                        aria-label="Default select example"
                                                        defaultValue=""
                                                        value={labAreaFilter}
                                                        onChange={e => {
                                                            setLabAreaFilter(e.target.value)
                                                        }}
                                                    >
                                                        <option value="">Seleccione el área de laboratorio</option>
                                                        {labareas.map((dir, index) => {
                                                            return <option key={index} value={dir.id}>{dir.name}</option>
                                                        })}
                                                    </select>
                                                </div>

                                                <div className="col-3 col-md-3 mx-2">
                                                    <label className='text-primary ml-1'>Cliente</label>
                                                    <Select
                                                        classNamePrefix="select2-selection"
                                                        placeholder="Seleccione cliente..."
                                                        isClearable
                                                        options={customers}
                                                        getOptionLabel={(option) =>
                                                            `${option.name ?? '-'}`
                                                        }
                                                        getOptionValue={(option) => `${option.id}`}
                                                        onChange={e => {
                                                            setCustomerFilter(e)
                                                        }}
                                                        value={customerFilter}
                                                    />
                                                </div>

                                                <div className="col-3 col-md-3 mx-2">
                                                    <label className='text-primary ml-1'>Asesor Técnico</label>
                                                    <Select
                                                        classNamePrefix="select2-selection"
                                                        placeholder="Seleccione Asesor Técnico..."
                                                        isClearable
                                                        options={techAdvisors}
                                                        getOptionLabel={(option) =>
                                                            `${option.name ?? '-'} ${option.surname ?? ''}`
                                                        }
                                                        getOptionValue={(option) => `${option.id}`}
                                                        onChange={e => {
                                                            setTechAdvFilter(e)
                                                        }}
                                                        value={techAdvFilter}
                                                    />
                                                </div>

                                                <button type="submit"
                                                    style={{ marginTop: 30, maxHeight: 40, marginLeft: 15 }}
                                                    className="btn btn-dark rounded-3 w-100"
                                                    onClick={onSearch}>
                                                    <span className="mdi mdi-magnify me-2"></span>Buscar
                                                </button>
                                            </div>

                                            <div className='d-flex align-items-start justify-content-start mb-3'>

                                                <div className='col-3 col-md-3 mx-2'>
                                                    <label htmlFor="exampleInputEmail" className='text-primary mt-3 rounded-3'>Tipo de Fecha</label>
                                                    <select onChange={onDateFilterChange}
                                                        value={dateFilter}
                                                        className="form-select text-primary rounded-3"
                                                        aria-label="Default select example" >
                                                        <option defaultValue>Seleccionar Tipo de Fecha</option>
                                                        <option value="1">Fecha de Solicitud</option>
                                                        <option value="2">Fecha de recepción de muestras</option>
                                                        <option value="3">Fecha de aceptación de solicitud</option>
                                                    </select>
                                                </div>

                                                <div className='col-3 col-md-3 mx-2'>
                                                    <label className='text-primary mt-3'>Fecha Inicio</label>
                                                    <Input
                                                        name="initialDate"
                                                        className="form-control rounded-3 text-primary"
                                                        type='date'
                                                        onChange={(e) => setInitialDate(e.target.value)}
                                                    />
                                                </div>

                                                <div className='col-3 col-md-3 mx-2'>
                                                    <label className='text-primary mt-3'>Fecha Fin</label>
                                                    <Input
                                                        name="endDate"
                                                        className="form-control rounded-3 text-primary"
                                                        type='date'
                                                        onChange={(e) => setEndDate(e.target.value)}
                                                    />
                                                </div>

                                                <Link className='btn rounded-3 w-100'
                                                    to={{
                                                        pathname: (activeTab === '1')
                                                            ? `${baseUrl}lab-requests/report/export-to-excel${paginationQuery}&reportType=roi${filterQuery}&laboratoryType=${citec}`
                                                            : `${baseUrl}lab-requests/report/export-to-excel${paginationQuery}&reportType=roi${filterQuery}&laboratoryType=${movil}`,
                                                    }} target='_blank'
                                                >
                                                    <button className='btn rounded-3 w-100' style={{ backgroundColor: 'green', color: 'white', marginTop: 45, maxHeight: 40, marginLeft: 15 }}>
                                                        <span className="mdi mdi-file-excel me-2"></span>Exportar Excel
                                                    </button>
                                                </Link>

                                            </div>
                                            <div className='d-flex align-items-start justify-content-start mb-3'>
                                                <div className="col-12 col-sm-12 col-md-12 col-lg-9 col-xl-12 col-xxl-12 mb-2 pe-2 ps-2">
                                                    <input
                                                        type="search"
                                                        value={serviceFilter}
                                                        onChange={onSearchChange}
                                                        className="form-control rounded-3 text-primary"
                                                        placeholder="Servicio..."
                                                        aria-label="Search"
                                                        name='inputSearchData'
                                                    />
                                                </div>
                                            </div>
                                            <div>
                                                <Table1
                                                    currentPage={currentPage}
                                                    getPagination={getPagination}
                                                    total={total} loading={loading}
                                                    isAddTableBorderStrap
                                                    columns={columns}
                                                    data={labRequestReportRois}
                                                    onPageSizeChange={(newSize) => setPageSizeCitec(newSize)}
                                                />
                                            </div>
                                        </TabPane>

                                        <TabPane tabId='2'>
                                            <div className='d-flex align-items-start justify-content-start'>
                                                <div className="col-3 col-md-3 mx-2">
                                                    <label className='text-primary ml-1'>Área de Laboratorio</label>
                                                    <select
                                                        className="form-select text-primary rounded-3"
                                                        aria-label="Default select example"
                                                        defaultValue=""
                                                        value={labAreaFilter}
                                                        onChange={e => {
                                                            setLabAreaFilter(e.target.value)
                                                        }}
                                                    >
                                                        <option value="">Seleccione el área de laboratorio</option>
                                                        {labareas.map((dir, index) => {
                                                            return <option key={index} value={dir.id}>{dir.name}</option>
                                                        })}
                                                    </select>
                                                </div>

                                                <div className="col-3 col-md-3 mx-2">
                                                    <label className='text-primary ml-1'>Cliente</label>
                                                    <Select
                                                        classNamePrefix="select2-selection"
                                                        placeholder="Seleccione cliente..."
                                                        isClearable
                                                        options={customers}
                                                        getOptionLabel={(option) =>
                                                            `${option.name ?? '-'}`
                                                        }
                                                        getOptionValue={(option) => `${option.id}`}
                                                        onChange={e => {
                                                            setCustomerFilter(e)
                                                        }}
                                                        value={customerFilter}
                                                    />
                                                </div>

                                                <div className="col-3 col-md-3 mx-2">
                                                    <label className='text-primary ml-1'>Asesor Técnico</label>
                                                    <Select
                                                        classNamePrefix="select2-selection"
                                                        placeholder="Seleccione Asesor Técnico..."
                                                        isClearable
                                                        options={techAdvisors}
                                                        getOptionLabel={(option) =>
                                                            `${option.name ?? '-'} ${option.surname ?? ''}`
                                                        }
                                                        getOptionValue={(option) => `${option.id}`}
                                                        onChange={e => {
                                                            setTechAdvFilter(e)
                                                        }}
                                                        value={techAdvFilter}
                                                    />
                                                </div>

                                                <button type="submit"
                                                    style={{ marginTop: 30, maxHeight: 40, marginLeft: 15 }}
                                                    className="btn btn-dark rounded-3 w-100"
                                                    onClick={onSearch}>
                                                    <span className="mdi mdi-magnify me-2"></span>Buscar
                                                </button>
                                            </div>

                                            <div className='d-flex align-items-start justify-content-start mb-3'>

                                                <div className='col-3 col-md-3 mx-2'>
                                                    <label htmlFor="exampleInputEmail" className='text-primary mt-3 rounded-3'>Tipo de Fecha</label>
                                                    <select onChange={onDateFilterChange}
                                                        value={dateFilter}
                                                        className="form-select text-primary rounded-3"
                                                        aria-label="Default select example" >
                                                        <option defaultValue>Seleccionar Tipo de Fecha</option>
                                                        <option value="1">Fecha de Solicitud</option>
                                                        <option value="2">Fecha de recepción de muestras</option>
                                                        <option value="3">Fecha de aceptación de solicitud</option>
                                                    </select>
                                                </div>

                                                <div className='col-3 col-md-3 mx-2'>
                                                    <label className='text-primary mt-3'>Fecha Inicio</label>
                                                    <Input
                                                        name="initialDate"
                                                        className="form-control rounded-3 text-primary"
                                                        type='date'
                                                        onChange={(e) => setInitialDate(e.target.value)}
                                                    />
                                                </div>

                                                <div className='col-3 col-md-3 mx-2'>
                                                    <label className='text-primary mt-3'>Fecha Fin</label>
                                                    <Input
                                                        name="endDate"
                                                        className="form-control rounded-3 text-primary"
                                                        type='date'
                                                        onChange={(e) => setEndDate(e.target.value)}
                                                    />
                                                </div>

                                                <Link className='btn rounded-3 w-100'
                                                    to={{
                                                        pathname: (activeTab === '1')
                                                            ? `${baseUrl}lab-requests/report/export-to-excel${paginationQuery}&reportType=roi${filterQuery}&laboratoryType=${citec}`
                                                            : `${baseUrl}lab-requests/report/export-to-excel${paginationQuery}&reportType=roi${filterQuery}&laboratoryType=${movil}`,
                                                    }} target='_blank'
                                                >
                                                    <button className='btn rounded-3 w-100' style={{ backgroundColor: 'green', color: 'white', marginTop: 45, maxHeight: 40, marginLeft: 15 }}>
                                                        <span className="mdi mdi-file-excel me-2"></span>Exportar Excel
                                                    </button>

                                                </Link>

                                            </div>
                                            <div className='d-flex align-items-start justify-content-start mb-3'>
                                                <div className="col-12 col-sm-12 col-md-12 col-lg-9 col-xl-12 col-xxl-12 mb-2 pe-2 ps-2">
                                                    <input
                                                        type="search"
                                                        value={serviceFilter}
                                                        onChange={onSearchChange}
                                                        className="form-control rounded-3 text-primary"
                                                        placeholder="Servicio..."
                                                        aria-label="Search"
                                                        name='inputSearchData'
                                                    />
                                                </div>
                                            </div>
                                            <div>
                                                <Table1
                                                    currentPage={currentPage}
                                                    getPagination={getPagination}
                                                    total={total}
                                                    loading={loading}
                                                    isAddTableBorderStrap
                                                    columns={columns}
                                                    data={labRequestReportRois}
                                                    onPageSizeChange={(newSize) => setPageSizeMovil(newSize)}
                                                />
                                            </div>

                                        </TabPane>

                                    </TabContent>

                                </div>

                            </Card>

                            <br />
                            <br />

                        </Card>
                    </Col>
                </Container>
            </div>
        </>
    )
}
